import { getUser } from 'utils/authService'

export const getZESettings = () => {
  const user = getUser()

  return {
    webWidget: {
      launcher: {
        chatLabel: {
          '*': 'Live Chat'
        }
      },
      color: { theme: '#61bd4f' },
      contactForm: {
        fields: [
          { id: 'name', prefill: { '*': user?.name } },
          { id: 'email', prefill: { '*': user?.sub } }
        ]
      },
      chat: {
        concierge: {
          name: 'Laura',
          title: { '*': 'Live support' }
        }
      }
    }
  }
}

export const getVisitorInfo = () => {
  const user = getUser()

  return {
    name: user?.name,
    email: user?.sub
  }
}
